import React, {useEffect} from 'react'
import Expired from '../../media/felsv/session_expired.svg'
import User from '../../media/felsv/DarkUser.svg'
import {Link} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import { clearDataRedux } from '../../actions/userLogin.actions'
import { KEYS } from '../../constants/keysStorage'


const SesionCaducada = (props: any) => {
  const dispatch = useDispatch()
  const mensajeGuardado = `${localStorage.getItem(KEYS.MESSAGE_SESSION_ERROR) ?? ''}`.trim()
  const message =
    mensajeGuardado === '' || mensajeGuardado === 'undefined' || mensajeGuardado === 'null'
      ? ''
      : mensajeGuardado


  useEffect(() => {
    dispatch(clearDataRedux())
  }, [])


  return (
    <div style={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '100vh',}}>
      <div>
        <div style={{textAlign: 'center'}}>
          <img src={User} alt='expired user' style={{width: '150px'}} />
          <img src={Expired} alt='expiren session' style={{width: '60px'}} />
        </div>
        <div style={{width: '70%', margin: '0 auto', textAlign: 'center'}}>
          <h2>
            {
              message?
                message
              : "Lamentablemente, tu sesión ha finalizado."
            }
          </h2></div>
        <div style={{width: '50%', margin: '5% auto'}}><Link to='/' className='m button w-inline-block'><div>Ir a Login</div></Link>
        </div>
      </div>
    </div>
  )
}

export default SesionCaducada
